/* This file is autogenerated, see readme.md for instructions */
import MinusSvgIcon from '@bloomreach/banana-theme/icons/minus.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MinusIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MinusSvgIcon />
    </Icon>
  );
});

MinusIcon.displayName = 'MinusIcon';

export default MinusIcon;
